import i18n from 'i18next';
import { useCallback, useEffect, useState } from 'react';
import { LocalStorageItems } from 'shared/constants';

export default function useI18nLanguage(): [ string, (language: string) => void ] {
    const [ language, setLanguage ] = useState(i18n.language);

    useEffect(() => {
        const handler = (lng: string) => setLanguage(lng);
        i18n.on('languageChanged', handler);

        return () => {
            i18n.off('languageChanged', handler);
        };
    }, []);

    const changeLanguageManually = useCallback((language: string) => {
        i18n.changeLanguage(language);

        localStorage.setItem(LocalStorageItems.SELECTED_LANGUAGE, language);
    }, []);

    return [ language, changeLanguageManually ];
}
